import { CASE_RESULTS, TRUST_BADGES } from "@/pages/landing/config";

export const RESULTS_DISCLAIMER = "Past results do not guarantee, warrant, or predict future outcomes. Every case is different — amounts shown are gross recoveries before fees and costs.";
export const NO_FEE_DEFAULT = { title: "The fee is free. Only pay if we win.", items: ["No upfront costs", "No hourly rates", "No retainer fee"] };

// null = each page keeps its own wording for that section.
export const SHARED_DEFAULTS = {
  trust_badges: TRUST_BADGES.map(({ title, sub }) => ({ title, sub })),
  case_results: CASE_RESULTS.map(({ amount, label }) => ({ amount, label })),
  results_disclaimer: RESULTS_DISCLAIMER,
  how_it_works: null,
  faq: null,
  final_cta: null,
  no_fee: NO_FEE_DEFAULT,
  articles: [],
  footer_note: "",
};

export const fillFirm = (text, firm, fallback = "an experienced attorney") => (text || "").split("{firm}").join(firm || fallback);
